import {
  commitHeaderEdit,
  manualOverride,
  rejectBatch,
} from "./api/batch-fix";
import { RetryAction } from "./RetryAction";
import { OverrideAction } from "./OverrideAction";
import { RejectAction } from "./RejectAction";

interface ActionPaneProps {
  batchId: string;
  candidateForms: Array<{
    jobTypeId: string;
    name: string;
    formVersionId: string;
  }>;
  role: "keyer" | "supervisor" | "admin";
  onAfterAction: () => void;
  previewOk: boolean;
  editedHeader?: string;
  headerFormat?: "xml" | "json";
}

export function ActionPane({
  batchId,
  candidateForms,
  role,
  onAfterAction,
  previewOk,
  editedHeader,
  headerFormat,
}: ActionPaneProps) {
  const canOverride = role === "supervisor" || role === "admin";
  const canReject = role === "supervisor" || role === "admin";

  return (
    <div className="action-pane">
      <h3>Actions</h3>
      <RetryAction
        disabled={!previewOk}
        onRetry={async () => {
          if (editedHeader && headerFormat) {
            await commitHeaderEdit(batchId, {
              rawHeader: editedHeader,
              format: headerFormat,
            });
            onAfterAction();
          }
        }}
      />
      {canOverride && (
        <OverrideAction
          candidateForms={candidateForms}
          onOverride={async (formVersionId, reason) => {
            await manualOverride(batchId, { formVersionId, reason });
            onAfterAction();
          }}
        />
      )}
      {canReject && (
        <RejectAction
          onReject={async (reason) => {
            await rejectBatch(batchId, { reason });
            onAfterAction();
          }}
        />
      )}
    </div>
  );
}
